<template>
  <a-card size="small">
    <template #title>待选列表 - {{ value.length }}项</template>
    <template #extra>
      <a-button size="small" type="link" @click="remove">删除选中</a-button>
    </template>
    <table-wrapper
      :dataSource="value"
      @onSelectionChange="onSelectionChange"
      :columns="columns"
      :tableHeight="tableHeight2"
    ></table-wrapper>
  </a-card>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive, toRefs,Ref } from "vue";
import { columns } from "./constant";
import { LibraryListRecord } from "@/views/material/library/library.interface";
import { computed } from "@vue/reactivity";

export default defineComponent({
  name: "SelectedTable",
  props: {
    tableHeight:{type:Number,default:0},
    value: {
      type: Array as PropType<LibraryListRecord[]>,
      default: [],
    },
    hideColumn: { type: Array as PropType<any[]>, default: () => [] },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const state = reactive<{
      current: number;
      selectedIds: string[];
      columns: any[];
      tableHeight2:Ref<Number>
    }>({
      current: 1,
      selectedIds: [],
      columns: columns.filter((item) => !props.hideColumn.includes(item.dataIndex)),
      tableHeight2:computed(()=>{
        return props.tableHeight-70;
      })
    });

    const onSelectionChange = (ids: string[]) => {
      state.selectedIds = ids;
    };

    const onTableChange = async (pagination) => {
      state.current = pagination.current;
    };

    const remove = () => {
      const newValue = (props.value || []).filter((item) => !state.selectedIds.includes(item.id));
      emit("update:value", newValue);
    };

    return {
      ...toRefs(state),
      onSelectionChange,
      onTableChange,
      remove,
    };
  },
});
</script>
